let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("47BJJ")).then(() => parcelRequire('2SBvi'));